import {oauthApi} from 'sources/api';
import {Map} from 'immutable';
import {NylasEnvironment, NylasState} from '@store/@types/nylas/NylasIntegration';
import {UserId} from 'records/User';

export class NylasIntegrationSource {
  static fetchNylasEnvironment(): Promise<NylasEnvironment> {
    return oauthApi.getJson('/nylas/environment');
  }

  static fetchNylasConnections(userIds: UserId[]): Promise<Map<UserId, boolean>> {
    return oauthApi
      .getJson<Record<UserId, boolean>>('/nylas_enabled', {params: {user_ids: userIds}})
      .then(res => Map(res));
  }

  static fetchNylasState(): Promise<NylasState> {
    return oauthApi.getJson('/nylas_state');
  }

  static fetchCalendarEmail(): Promise<string> {
    return oauthApi.getJson('/nylas_email');
  }

  static forgetNylasConnection(): Promise<void> {
    return oauthApi.delete('/nylas');
  }
}
